/* eslint-disable no-restricted-imports */
import { Skeleton as MuiSkeleton, SkeletonProps } from '@mui/material';
import { TestIds } from '@watershed/shared-universal/utils/testUtils';

export default function Skeleton(props: SkeletonProps) {
  return <MuiSkeleton {...props} data-test={TestIds.LoadingStateSkeleton} />;
}
